export default "<button type=\"button\" class=\"av-tab-button\" [class.av-tab-button--active]=\"active\">\r\n    <ng-content></ng-content>\r\n</button>\r\n";